<script>
import axios from 'axios';

export default class ConsultorBloqueiosRepository {
    async getBloqueios(token, params = {}) {
        const baseURL = process.env.VUE_APP_API_URL + "consultores/bloqueios";
        const headers = { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json' };
        return await axios.get(baseURL, { headers, params });
    }

    async criarBloqueio(token, data) {
        const baseURL = process.env.VUE_APP_API_URL + "consultores/bloqueios";
        const headers = { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json', 'Content-Type': 'application/json' };
        return await axios.post(baseURL, data, { headers });
    }

    async atualizarBloqueio(token, id, data) {
        const baseURL = process.env.VUE_APP_API_URL + `consultores/bloqueios/${id}`;
        const headers = { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json', 'Content-Type': 'application/json' };
        return await axios.put(baseURL, data, { headers });
    }

    async removerBloqueio(token, id) {
        const baseURL = process.env.VUE_APP_API_URL + `consultores/bloqueios/${id}`;
        const headers = { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json' };
        return await axios.delete(baseURL, { headers });
    }

    async getConsultores(token) {
        const baseURL = process.env.VUE_APP_API_URL + "get-group-members/consultores";
        const headers = { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json' };
        return await axios.get(baseURL, { headers });
    }
}
</script>
